import { Form, Input } from 'antd';
import './index.scss';
const { TextArea } = Input;
export const useRepeatForm = (isDisabled: boolean = false) => {
  const repeatForm = (
    <div className="pc-footer-repeat">
      <Form.Item
        label={'备注：'}
        name={'recordRemark'}
        rules={[{ required: isDisabled }]}
      >
        <TextArea placeholder="输入备注内容" rows={3} />
      </Form.Item>
    </div>
  );
  return {
    repeatForm
  };
};
